import React from 'react';
import { Button, Form, Row, Col, Modal, InputGroup } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { KIEMTRASOLIEU_API } from '../../../../utils/apiUrl';
import { Post } from '../../../../utils/httpProvider';
import DocumentInput from '../../../../components/document-input/DocumentInput';
import { trangThaiKiemTraSoLieuValue } from '../../../../utils/define';

const schema = yup.object().shape({
    soLuongBaiBao: yup.number().nullable().typeError('Vui lòng nhập số').min(0, 'Số lượng bài báo không được âm').required('Vui lòng nhập số lượng bài báo'),
    trenCacTapChi: yup.string().required('Vui lòng nhập tên các tạp chí'),
    linkBaiBao: yup.string().nullable().test(
        'is-link-or-file-required',
        'Vui lòng nhập Link bài báo hoặc Gắn file',
        function (value) {
            const { fileBaiBao } = this.parent;
            if (!value && !fileBaiBao) {
                return false;
            }
            return true;
        }
    ),
    ngayKiemTra: yup.date().nullable(),
    fileVanBanDongY: yup.string().required('Vui lòng gắn file Văn bản đồng ý'),
    fileLuanAn: yup.string().required('Vui lòng gắn file Luận án')
});

const KiemTraSoLieuAdd = ({ hoSoId, setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) => Post(KIEMTRASOLIEU_API.CREATE, null, value, false));

    const handleCreate = (values, { setSubmitting }) => {
        const requestData = {
            hoSoNghienCuuSinhId: hoSoId,
            soLuongBaiBao: values.soLuongBaiBao ? Number(values.soLuongBaiBao) : null,
            trenCacTapChi: values.trenCacTapChi || '',
            linkBaiBao: values.linkBaiBao || '',
            ngayKiemTra: values.ngayKiemTra || null,
            fileBaiBao: values.fileBaiBao || '',
            fileVanBanDongY: values.fileVanBanDongY || '',
            fileDanhSach: values.fileDanhSach || '',
            fileXacNhan: values.fileXacNhan || '',
            fileLuanAn: values.fileLuanAn || '',
            fileMinhChung: values.fileMinhChung || '',
            trangThai: trangThaiKiemTraSoLieuValue.choDuyet
        };

        addFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.id)) {
                    toast.success('Thêm mới thành công');
                    queryClient.invalidateQueries(['kiemTraSoLieuData', hoSoId]);
                    if (refreshList) refreshList();
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="xl" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Thêm mới Kiểm tra số liệu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleCreate}
                    initialValues={{
                        soLuongBaiBao: '',
                        trenCacTapChi: '',
                        linkBaiBao: '',
                        ngayKiemTra: '',
                        fileBaiBao: '',
                        fileVanBanDongY: '',
                        fileDanhSach: '',
                        fileXacNhan: '',
                        fileLuanAn: '',
                        fileMinhChung: ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting, setFieldValue, submitCount }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="bg-light text-center">
                                        <tr>
                                            <th width="60" className="text-center font-weight-bold">TT</th>
                                            <th width="45%" className="text-center font-weight-bold">Điều kiện</th>
                                            <th className="text-center font-weight-bold">Hành động</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-center" style={{ fontWeight: 500 }} rowSpan={5}>1</td>
                                            <td style={{ fontWeight: 500 }}>Bài báo khoa học</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Số lượng bài báo <span className="text-danger">*</span></td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    name="soLuongBaiBao"
                                                    value={values.soLuongBaiBao}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Nhập số lượng bài báo..."
                                                    min="0"
                                                />
                                                {submitCount > 0 && errors.soLuongBaiBao && <div className="text-danger small mt-1">{errors.soLuongBaiBao}</div>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Trên các tạp chí <span className="text-danger">*</span></td>
                                            <td>
                                                <Form.Control
                                                    type="text"
                                                    name="trenCacTapChi"
                                                    value={values.trenCacTapChi}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Nhập tên tạp chí..."
                                                />
                                                {submitCount > 0 && errors.trenCacTapChi && <div className="text-danger small mt-1">{errors.trenCacTapChi}</div>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Link bài báo <span className="text-danger">*</span></td>
                                            <td>
                                                <InputGroup>
                                                    <Form.Control
                                                        type="text"
                                                        name="linkBaiBao"
                                                        value={values.linkBaiBao}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        placeholder="Nhập link bài báo..."
                                                    />
                                                    {values.linkBaiBao && (
                                                        <InputGroup.Append>
                                                            <a 
                                                                href={values.linkBaiBao.startsWith('http') ? values.linkBaiBao : `http://${values.linkBaiBao}`} 
                                                                target="_blank" 
                                                                rel="noreferrer" 
                                                                className="btn btn-outline-primary"
                                                                title="Mở link bài báo"
                                                            >
                                                                <i className="fas fa-external-link-alt"></i>
                                                            </a>
                                                        </InputGroup.Append>
                                                    )}
                                                </InputGroup>
                                                {submitCount > 0 && errors.linkBaiBao && <div className="text-danger small mt-1">{errors.linkBaiBao}</div>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Gắn file (nếu không có đường link)</td>
                                            <td>
                                                <DocumentInput
                                                    labelTitle=""
                                                    value={values.fileBaiBao}
                                                    onChangeProp={(url) => setFieldValue('fileBaiBao', url)}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center" style={{ fontWeight: 500 }}>2</td>
                                            <td style={{ fontWeight: 500 }}>Văn bản đồng ý của các đồng tác giả <span className="text-danger">*</span></td>
                                            <td>
                                                <DocumentInput
                                                    labelTitle=""
                                                    value={values.fileVanBanDongY}
                                                    onChangeProp={(url) => setFieldValue('fileVanBanDongY', url)}
                                                />
                                                {submitCount > 0 && errors.fileVanBanDongY && <div className="text-danger small mt-1">{errors.fileVanBanDongY}</div>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center" style={{ fontWeight: 500 }}>3</td>
                                            <td style={{ fontWeight: 500 }}>Danh sách bệnh nhân</td>
                                            <td>
                                                <DocumentInput
                                                    labelTitle=""
                                                    value={values.fileDanhSach}
                                                    onChangeProp={(url) => setFieldValue('fileDanhSach', url)}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center" style={{ fontWeight: 500 }}>4</td>
                                            <td style={{ fontWeight: 500 }}>Xác nhận đơn vị xử lý số liệu</td>
                                            <td>
                                                <DocumentInput
                                                    labelTitle=""
                                                    value={values.fileXacNhan}
                                                    onChangeProp={(url) => setFieldValue('fileXacNhan', url)}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center" style={{ fontWeight: 500 }}>5</td>
                                            <td style={{ fontWeight: 500 }}>Luận án đã thông qua bộ môn <span className="text-danger">*</span></td>
                                            <td>
                                                <DocumentInput
                                                    labelTitle=""
                                                    value={values.fileLuanAn}
                                                    onChangeProp={(url) => setFieldValue('fileLuanAn', url)}
                                                />
                                                {submitCount > 0 && errors.fileLuanAn && <div className="text-danger small mt-1">{errors.fileLuanAn}</div>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-center" style={{ fontWeight: 500 }}>6</td>
                                            <td style={{ fontWeight: 500 }}>Thời gian dự kiến kiểm tra</td>
                                            <td>
                                                <Form.Control
                                                    type="date"
                                                    name="ngayKiemTra"
                                                    value={values.ngayKiemTra}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="text-right mt-3">
                                <Button
                                    variant="secondary"
                                    onClick={() => setViewMode('list')}
                                    className="mr-2"
                                >
                                    Hủy
                                </Button>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? <><i className="fas fa-spinner fa-spin mr-1"></i> Thêm</> : 'Thêm'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default KiemTraSoLieuAdd;
